import { computed, inject, Injectable } from '@angular/core';
import { Modal, SettingsService } from 'army-builder-shared';

@Injectable({ providedIn: 'root' })
export class VoucherService {
    settingsService = inject(SettingsService);

    user = computed(() => this.settingsService.login()?.user);
    metadata = computed(() => this.user()?.metadata);
    lastVoucherDate = computed(() => {
        let voucherCodes = this.voucherCodes();
        if (voucherCodes.length === 0) {
            return null;
        }

        let lastVoucherDate = null;
        for (let voucher of voucherCodes) {
            let voucherDate = new Date(voucher.date);
            if (!lastVoucherDate || voucherDate > lastVoucherDate) {
                lastVoucherDate = voucherDate;
            }
        }
        return lastVoucherDate;
    });
    modal = inject(Modal);

    annualEntitlement = computed(() => {
        let user = this.user();
        let annualSub = user?.entitlements?.app_sub_annual;
        return annualSub;
    });

    latestAnnualSubscriptionDate = computed(() => {
        let annualSub = this.annualEntitlement();
        if (annualSub?.purchase_date) {
            let res = new Date(annualSub?.purchase_date);
            return res;
        }
        return null;
    });

    voucherCodes = computed(
        () => [...(this.metadata()?.voucher || [])].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()) || []
    );

    canGenerateNewVoucher = computed(() => {
        if (this.user()?.hasActiveBillingIssue) {
            return false;
        }

        let annualEntitlement = this.annualEntitlement();
        let expiryDate = annualEntitlement?.expires_date ? new Date(annualEntitlement.expires_date) : null;
        if (!annualEntitlement || !expiryDate || expiryDate.getTime() < Date.now()) {
            return false;
        }

        let lastVoucherDate = this.lastVoucherDate();
        if (!lastVoucherDate) {
            return true;
        }
        let latestAnnualSubscriptionDate = this.latestAnnualSubscriptionDate();
        if (latestAnnualSubscriptionDate > lastVoucherDate) {
            return true;
        }
        return false;
    });

    showReminder = computed(() => {
        const user = this.user();
        if (!user) {
            return false;
        }

        // Use debounced settings to ensure they're fully loaded
        let settings = this.settingsService.settingsDebounced();
        const settingsLoaded = !!settings?.settingsLoaded;
        let showVoucherReminder = settings?.global?.showVoucherReminder;
        console.log(
            '[Voucher] showReminder check - settingsLoaded:',
            settingsLoaded,
            'showVoucherReminder:',
            showVoucherReminder,
            'canGenerate:',
            this.canGenerateNewVoucher()
        );
        if (!settingsLoaded || showVoucherReminder === false) {
            return false;
        }
        return this.canGenerateNewVoucher();
    });
}
